export const commonRoutes = Object.freeze({
  QrPage: "/qr-page",
  QrExpired: "/qr-expired",
  MerchantConfiguration: "/merchant-configuration",
  Widget: "/widget",
  LoadingPage: "/",
  CrediteaPayIntroduction: "/creditea-pay-introduction",
  CustomerDataBasic: "/customer-data-basic",
  SuccessPage: "/success-page",
  TimeUp: "/time-up",
  PaymentFailed: "/payment-failed",
  PaymentConfirmationError: "/payment-confirmation-error",
  SorryPage: "/sorry-page",
  WrongDataRejection: "/wrong-data-rejection",
  ReturnHome: "/return-home",
  ErrorPage: "/error-page",
  NotFoundPage: "/*",
});

export const existingCustomerRoutes = Object.freeze({
  DrawSimulation: "/draw-simulation",
  NegativeDrawSimulation: "/negative-draw-simulation",
  OTPCheck: "/otp-check",
  OTPSuccess: "/otp-success",
});

export const newCustomerRoutes = Object.freeze({
  CustomerDataDetailed: Object.freeze({
    PersonalData: "/customer-data-detailed/personal-data",
    ResidentialAddress: "/customer-data-detailed/residential-address",
    EmploymentData: "/customer-data-detailed/employment-data",
  }),
  ApplicationConfirmation: "/application-confirmation",
  OfferAvailable: "/offer-available",
  OfferAvailablePending: "/offer-available-pending",
  DebitCardRegistration: "/debit-card-registration",
  DebitCardRegistrationSuccess: "/debit-card-registration-success",
  IdentityVerification: "/identity-verification",
  OnfidoVerification: "/onfido-verification",
  OnfidoVerificationPending: "/onfido-verification-pending",
  OnfidoVerificationSuccess: "/onfido-verification-success",
  SubmitingPage: "/submiting-page",
  WaitingPage: "/waiting-page",
  UploadFiles: "/upload-files",
  FieldRequired: "/field-required",
});
